// Layout constants (no actor definitions — actors are data-driven)
export const ACTION_SPACING = 180; // Vertical space between actions
export const START_Y = 120; // Initial Y position for first action
export const SEGMENT_HEIGHT = 80; // Height of each segment

// Dynamic positioning
export const MIN_ACTOR_SPACING = 250; // Minimum horizontal spacing between actors
export const DIAGRAM_MARGIN = 100; // Left margin before first actor
